import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class AccessoryService {

   private apiUrl = this.appProfile.ampmUs+'/ems/fhir/'+this.appProfile.org+'/Device';

  constructor(private http: HttpClient, private authService: AuthService, private appProfile: AppProfile) { }
  createDevice(payload: any, type: 'cushion' | 'breathingCircuit'): Observable<any> {
  const token = this.authService.accessToken;

  const headers = new HttpHeaders({
    'X-tenant-Id': this.appProfile.tenant,
    'api-version': '1.0.0',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.authService.accessToken}`,
  });

  return this.http.post(this.apiUrl, payload, { headers });
}
}
